export const fieldNames = {
  executeDateTime: 'executeDateTime',
  note: 'note',
};

export const apiKeys = {
  executeDate: 'executeDate',
  note: 'note',
};
